<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Atendimento do Cliente</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">
                {{ countFilter }}
              </span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Atendimentos</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 v-if="pagination.TotalItems > 0" class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0" :class="window.width < 1880 ? 'dropleft' : ''">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      id="dropdownMenuButton"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div class="dropdown-menu" id="dropTableOptions" aria-labelledby="dropdownMenuButton">
                      <a
                        class="dropdown-item"
                        :class="loadingList ? 'disabled' : ''"
                        href="#"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingList">
                          <loader :small="true" :isLoading="loadingList" />
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Data</th>
                    <th scope="col" class="border-0 text-left">Usuário</th>
                    <th scope="col" class="border-0 text-left">Descrição</th>
                    <th scope="col" class="border-0 text-left">Categoria</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(note, index) in notes" :key="index">
                    <td></td>
                    <td class="text-left">
                      {{ note.CreatedDate | date }}
                    </td>
                    <td class="text-left">{{ note.UserInternal.Name }}</td>
                    <td class="text-left">
                      {{ note.Description | ellipsis(80) }}
                    </td>
                    <td class="text-left">
                      {{ note.CustomerServiceCategory.Name }}
                    </td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a
                            v-if="$isAuthorize('MerchantNote', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenNote($event, index, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="note.UserInternal.Id == $getUserInternal().Id && $isAuthorize('MerchantNote', 'Update')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenNote($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="notes == null || notes == undefined || notes.length == 0">
                    <td colspan="5">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    aria-controls="my-table"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                  />
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="mFormNote" size="lg" :title="modalTitle" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <ValidationObserver ref="NoteValidationForm">
          <d-form-row>
            <d-col md="8" class="form-group">
              <label>Usuário</label>
              <ValidationProvider vid="idUserInternal" v-slot="{ errors, invalid }">
                <d-select
                  :class="validatedFormValidation | showValidateError(invalid)"
                  v-model="infoNote.UserInternal.Id"
                  :disabled="true"
                >
                  <option :value="0" selected>Selecione</option>
                  <option v-for="user in usersInternal" v-bind:value="user.Id" v-bind:key="user.Id">
                    {{ user.Name }}
                  </option>
                </d-select>
                <div class="invalid-feedback d-block" v-if="validatedFormValidation">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="4" class="form-group">
              <label>Categoria</label>
              <ValidationProvider rules="required" vid="idCustomerServiceCategory" v-slot="{ errors, invalid }">
                <d-select
                  :class="validatedFormValidation | showValidateError(invalid)"
                  v-model="infoNote.CustomerServiceCategory.Code"
                  :disabled="isSeeing"
                >
                  <option :value="null" selected>Selecione...</option>
                  <template v-if="!isSeeing">
                    <option v-for="csc in customerServiceCategoriesForm" :value="csc.Code" :key="csc.Code">
                      {{ csc.Code }} - {{ csc.Name }}
                    </option>
                  </template>
                  <template v-else>
                    <option v-for="csc in customerServiceCategoriesFilter" :value="csc.Code" :key="csc.Code">
                      {{ csc.Code }} - {{ csc.Name }}
                    </option>
                  </template>
                </d-select>
                <div class="invalid-feedback d-block" v-if="validatedFormValidation">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="12" class="form-group">
              <ValidationProvider rules="required|max:2000" v-slot="{ errors, invalid }">
                <label>Descrição</label>
                <b-form-textarea
                  :class="validatedFormValidation | showValidateError(invalid)"
                  type="text"
                  v-model="infoNote.Description"
                  :disabled="isSeeing"
                  rows="6"
                />
                <div class="invalid-feedback d-block" v-if="validatedFormValidation">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveNote()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ isCreating ? " Adicionar" : " Salvar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal id="mFilter" title="Filtros" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <d-form-row>
        <d-col md="8" class="form-group">
          <label>Usuário</label>
          <d-select v-model="filter.IdUserInternal" :value="null">
            <option :value="null" selected>Selecione...</option>
            <option v-for="user in usersInternal" v-bind:value="user.Id" v-bind:key="user.Id">
              {{ user.Name }}
            </option>
          </d-select>
        </d-col>
        <!-- CustomerServiceCategory -->
        <d-col md="4" class="form-group">
          <label>Categoria</label>
          <d-select v-model="filter.CodeCustomerServiceCategory">
            <option :value="null" selected>Selecione...</option>
            <option v-for="csc in customerServiceCategoriesFilter" :value="csc.Code" :key="csc.Code">
              {{ csc.Code }} - {{ csc.Name }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button variant="primary" class="btn btn-primary" v-b-tooltip.hover.bottom title="Pesquisar" @click="Filter()">
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo Atendimento"
      v-if="this.idMerchant != null && $isAuthorize('MerchantNote', 'Add')"
      v-on:click="OpenNote($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
export default {
  name: "merchant-notes",
  data: function () {
    return {
      idMerchant: null,
      countFilter: 0,
      filter: {
        IdMerchant: null,
        IdUserInternal: null,
        CodeCustomerServiceCategory: null,
      },
      validatedFormValidation: false,
      loadingList: false,
      loadingAddUpdate: false,
      loadingModal: false,
      idMerchantNote: 0,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      notes: [],
      usersInternal: [],
      customerServiceCategoriesFilter: [],
      customerServiceCategoriesForm: [],
      infoNote: {
        Merchant: {
          Id: this.idMerchant,
        },
        UserInternal: {
          Id: this.$getUserInternal().Id,
        },
        CustomerServiceCategory: {
          Code: null,
        },
        Description: null,
      },
      isSeeing: false,
      isCreating: false,
      modalTitle: "Novo atendimento",
      window: {
        width: 0,
        height: 0,
      },
    };
  },
  watch: {
    "pagination.PageNumber": function () {
      this.ListNote();
    },
    "pagination.RowsPerPage": function () {
      this.ListNote();
    },
  },
  mounted() {
    if (this.$route.params.idMerchant !== null && this.$route.params.idMerchant !== undefined) {
      this.idMerchant = this.$route.params.idMerchant;
    }
    this.ListCustomerServiceCategory();
    this.ListNote();
    this.ListUserInternal();
  },
  methods: {
    ResetInfoNote: function () {
      this.infoNote = {
        Merchant: {
          Id: this.idMerchant,
        },
        UserInternal: {
          Id: this.$getUserInternal().Id,
        },
        CustomerServiceCategory: {
          Code: null,
        },
        Description: null,
      };
    },
    SaveNote() {
      this.validatedFormValidation = true;
      this.$refs.NoteValidationForm.validate().then((isValid) => {
        if (isValid) {
          if (this.isCreating) {
            // Add
            this.loadingAddUpdate = true;
            this.loadingModal = true;
            this.$store
              .dispatch("AddMerchantNote", this.infoNote)
              .then(() => {
                this.$makeToast("Sucesso ao adicionar o atendimento", "success", "Atendimentos do cliente");
                this.ListNote();
                this.$bvModal.hide("mFormNote");
              })
              .catch((error) => {
                this.$makeToast("Não foi possível adicionar o atendimento", "danger", "Atendimentos do cliente", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.loadingModal = false;
              });
          } else {
            // Update
            this.$store
              .dispatch("UpdateMerchantNote", this.infoNote)
              .then(() => {
                this.$makeToast("Suas modificações foram salvas na base de dados", "success", "Atendimentos do cliente");
                this.ListNote();
                this.$bvModal.hide("mFormNote");
              })
              .catch((error) => {
                this.$makeToast(undefined, "danger", "Erro ao atualizar o atendimento", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },

    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListNote();
    },

    GetParamsList(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.Merchant.Id": hasValue(this.filter.IdMerchant) ? this.filter.IdMerchant : 0,
        "Object.UserInternal.Id": this.filter.IdUserInternal,
        "Object.CustomerServiceCategory.Code": this.filter.CodeCustomerServiceCategory,
      };
      delete data.TotalItems;

      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },

    ListNote: function () {
      this.countFilter = 0;

      if (this.idMerchant !== null) this.filter.IdMerchant = this.idMerchant;
      if (hasValue(this.filter.IdUserInternal)) this.countFilter++;
      if (hasValue(this.filter.CodeCustomerServiceCategory)) this.countFilter++;

      this.loadingList = true;
      let data = this.GetParamsList();
      delete data.TotalItems;
      this.$store
        .dispatch("ListMerchantNote", { params: data })
        .then(
          (response) => {
            this.notes = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          },
          (error) => {
            this.$makeToast("Não foi possível listar os atendimentos", "danger", "Atendimentos dos Clientes", error);
          }
        )
        .finally(() => {
          this.loadingList = false;
        });
    },

    ListUserInternal: function () {
      this.$store
        .dispatch("ListUserInternal", { params: {} })
        .then((response) => {
          this.usersInternal = response.Objects;
        })
        .catch((error) => {
          this.$makeToast("Tente atualizar a página", "danger", "Erro ao obter lista de usuários", error);
        });
    },

    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },

    ResetFilter: function () {
      this.filter = {
        IdMerchant: this.idMerchant,
        IdUserInternal: null,
        CodeCustomerServiceCategory: null,
      };
      this.ListNote();
    },

    OpenNote: function (e, i, view) {
      e.preventDefault();
      this.validatedFormValidation = false;
      this.loadingAddUpdate = false;
      this.ResetInfoNote();

      if (view == undefined && i != undefined) {
        // Edit
        this.isCreating = false;
        this.idNote = this.notes[i].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar atendimento ao cliente";
        this.GetNote(this.idNote);
      } else if (view == undefined && i == undefined) {
        // Add new
        this.isCreating = true;
        this.isSeeing = false;
        this.modalTitle = "Novo atendimento ao cliente";
      } else {
        // View
        this.isCreating = false;
        this.idNote = this.notes[i].Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes do atendimento ao cliente";
        this.GetNote(this.idNote);
      }
      this.$bvModal.show("mFormNote");
    },

    GetNote: function (id) {
      this.loadingModal = true;
      this.$store
        .dispatch("GetMerchantNote", { id: id })
        .then((response) => {
          this.infoNote = response;
          this.$bvModal.show("mFormNote");
        })
        .catch((error) => {
          this.$makeToast(
            "Não foi possível buscar as informações do atendimento",
            "danger",
            "Atendimentos do cliente",
            error
          );
        })
        .finally(() => {
          this.loadingModal = false;
        });
    },

    ListCustomerServiceCategory() {
      this.$store
        .dispatch("ListCustomerServiceCategory", { ListActiveAndExcluded: true })
        .then((response) => {
          const CSC = response.Objects;
          if (CSC.length > 0) {
            this.customerServiceCategoriesFilter = CSC;
            this.customerServiceCategoriesForm = CSC.filter((category) => !category.IsExcluded);
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Um erro ocorreu ao listar os campos. Tente novamente.",
            "danger",
            "Erro ao listar os Campos",
            error
          );
        });
    },

    GetReport() {
      this.loadingList = true;
      const params = this.GetParamsList(true);
      this.$store
        .dispatch("ReportMerchantNote", { params })
        .then((response) => {
          if (hasValue(response.UrlReport)) {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingList = false;
          }, 1200);
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/pages/merchantNotes.vue